const OurValuesData = [
  {
    id: 0,
    icon: "/assets/about/StarIcon.png",
    title: "Trust",
    text: " Trust is the cornerstone of every successful real estate transaction.",
    className: "",
  },
  {
    id: 1,
    icon: "/assets/about/ExcellenceIcon.png",
    title: " Excellence",
    text: "We set the bar high for ourselves. From the properties we list   to the services we provide.",
    className: "br",
  },
  {
    id: 2,
    icon: "/assets/about/ClientIcon.png",
    title: "Client-Centric",
    text: "Your dreams and needs are at the center of our universe. We listen, understand.",
    className: "",
  },
  {
    id: 3,
    icon: "/assets/about/StarIcon.png",
    title: "Our Commitment",
    text: " We are dedicated to providing you with the highest level of service, professionalism, and support.",
    className: "br",
  },
];

export default OurValuesData;
